import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TourService } from 'ngx-ui-tour-md-menu'
import moment from "moment";
import Swal from 'sweetalert2';
import { ProjectService } from 'src/app/Services/project.service';
import { SharedService } from 'src/app/Services/sharedService';
import { TourConfigService } from 'src/app/Services/tour-config.service';
import { LoginService } from 'src/app/Services/login.service';
import { DownloadModalComponent } from 'src/app/Admin/create-user/download-modal/download-modal.component';
import { OnInit } from '@angular/core';
import { MagicLinkService } from 'src/app/Services/magic-link.service';
import { TokenEncryptionService } from 'src/app/Services/token-encryption.service';

@Component({
    selector: 'app-welcome-new-user',
    templateUrl: './welcome-new-user.component.html',
    styleUrl: './welcome-new-user.component.css',
    standalone: false
})
export class WelcomeNewUserComponent implements OnInit {
  userName: string = "";
  userEmail: string = "";
  currentTab: string = "tracking"
  eventTitle = 'Explore SuperSee - Productivity & Usage Insights';
  eventDetails = `Let’s take a moment to explore how SuperSee helps you:

* Track work patterns: idle, productive, and offline hours
* Monitor app and web usage in real time
* Get actionable insights and analytics

💡 Explore more at https://supersee.io

Need help? Chat with us anytime on WhatsApp: https://wa.me/916354719703`;
  eventLocation = 'Desktop (https://supersee.io)';
  icsDataUrl: any;
  nowPlus2Hours: string = moment().utc().add(2, 'hours').format('YYYYMMDDTHHmmss[Z]');
  isLoading: boolean = false;
  isMobile: boolean = false;

  // Timer functionality for magic link button
  isMagicLinkButtonDisabled = false;
  magicLinkTimer = 60; // 60 seconds = 1 minute
  magicLinkTimerInterval: any;

  @ViewChild('createNewEmployeeVideo') createNewEmployeeVideo!: ElementRef;
  @ViewChild('createNewEmployeeVideoMobileView') createNewEmployeeVideoMobileView!: ElementRef;
  constructor(
    public dialog: MatDialog,
    private _dialogRef: MatDialogRef<WelcomeNewUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _projectService: ProjectService,
    private _sharedServices: SharedService,
    private _tourConfig: TourConfigService,
    private tourService: TourService,
    private loginService: LoginService,
    private router: Router,
    private magicLinkService: MagicLinkService,
    private tokenEncryptionService: TokenEncryptionService
  ) {
    // You can initialize the userName here or fetch it from a service
    // For example, if you have a user service, you could do something like:
    // this.userName = this.userService.getUserName();
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    if (this.data && this.data.takeTour) {
      this.tourModal()
    }

    this.getUserFromLocalStorage();
    this.generateICSFileDataUrl();
    this.isMobile = (window.innerWidth <= 768) || /Mobi|Android/i.test(navigator.userAgent);
  }

  ngOnDestroy() {
    // Clean up timer interval if component is destroyed
    if (this.magicLinkTimerInterval) {
      clearInterval(this.magicLinkTimerInterval);
    }
  }

  ngAfterViewInit(): void {
    this.loadVideo();
  }

  addFirstEmployee() {
    this.router.navigate(['/employees'], { queryParams: { openCreateUser: 'true' } });
    this.closeModal();
  }

  tourModal() {
    localStorage.setItem('isTour', 'false')
    this._projectService.updateDashboardTourData({ data: 'false' })
  }

  closeModal() {
    this._dialogRef.close();
  }

  getUserFromLocalStorage() {
    const parsedUser = this.tokenEncryptionService.getEncryptedItem<any>('user');
    if (parsedUser) {
      this.userName = parsedUser.name; // Fallback to 'User' if name is not available
      this.userEmail = parsedUser.email || '';
    } else {
      this.userName = 'User'; // Default value if no user is found
      this.userEmail = '';
    }
  }

  loadVideo() {
    if (this.createNewEmployeeVideo && this.createNewEmployeeVideo.nativeElement) {
      const videoElement = this.createNewEmployeeVideo.nativeElement;

      // Force load the video
      videoElement.load();

      // Ensure video is muted to help with autoplay
      videoElement.muted = true;
      videoElement.defaultMuted = true;

      // Handle video loading errors
      videoElement.onerror = (e) => {
        console.error('Video loading error:', e);
      };

      // Log when video is loaded
      videoElement.onloadeddata = () => {
        console.log('Video loaded successfully');
      };

      // Add event listeners for document interaction
      const attemptPlay = () => {
        // Attempt to play the video
        const playPromise = videoElement.play();

        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              console.log('Video playback started successfully');
              // Remove event listeners once video plays
              document.removeEventListener('click', attemptPlay);
              document.removeEventListener('touchstart', attemptPlay);
            })
            .catch(error => {
              console.error('Video playback was prevented:', error);
            });
        }
      };

      // Try initial play (will likely fail due to autoplay policy)
      attemptPlay();

      // Set up listeners to try again on user interaction
      document.addEventListener('click', attemptPlay);
      document.addEventListener('touchstart', attemptPlay);
    }

    if (this.createNewEmployeeVideoMobileView && this.createNewEmployeeVideoMobileView.nativeElement) {
      const videoElement = this.createNewEmployeeVideoMobileView.nativeElement;

      console.log("videoElement", videoElement)
      // Force load the video
      videoElement.load();

      // Ensure video is muted to help with autoplay
      videoElement.muted = true;
      videoElement.defaultMuted = true;

      // Handle video loading errors
      videoElement.onerror = (e) => {
        console.error('Video loading error:', e);
      };

      // Log when video is loaded
      videoElement.onloadeddata = () => {
        console.log('Video loaded successfully');
      };

      // Add event listeners for document interaction
      const attemptPlay = () => {
        // Attempt to play the video
        const playPromise = videoElement.play();

        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              console.log('Video playback started successfully');
              // Remove event listeners once video plays
              document.removeEventListener('click', attemptPlay);
              document.removeEventListener('touchstart', attemptPlay);
            })
            .catch(error => {
              console.error('Video playback was prevented:', error);
            });
        }
      };

      // Try initial play (will likely fail due to autoplay policy)
      attemptPlay();

      // Set up listeners to try again on user interaction
      document.addEventListener('click', attemptPlay);
      document.addEventListener('touchstart', attemptPlay);
    }
  }

  get googleCalendarUrl() {
    return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(this.eventTitle)}&details=${encodeURIComponent(this.eventDetails)}&location=${encodeURIComponent(this.eventLocation)}`;
  }

  get outlookCalendarUrl() {
    const eventDetails = `
    Let’s take a moment to explore how SuperSee helps you: <br>
    <ul>
      <li>Track work patterns: idle, productive, and offline hours</li>
      <li>Monitor app and web usage in real time</li>
      <li>Get actionable insights and analytics</li>
    </ul>
    <br>
    💡 Explore more at https://supersee.io
    <br><br>
    Need help? Chat with us anytime on WhatsApp: https://wa.me/916354719703`;

    return `https://outlook.live.com/calendar/0/deeplink/compose?subject=${encodeURIComponent(this.eventTitle)}&body=${encodeURIComponent(eventDetails)}&location=${encodeURIComponent(this.eventLocation)}`;
  }

  get icsContent() {
    const base = this.nowPlus2Hours.replace('Z', '');
    return `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Supersee //Calendar Event//EN
BEGIN:VEVENT
UID:hello@raoinformationtechnology.com
DTSTAMP:${this.nowPlus2Hours}
DTSTART:${this.nowPlus2Hours}
DTEND:${moment.utc(base, 'YYYYMMDDTHHmmss').add(30, 'minutes').format('YYYYMMDDTHHmmss[Z]')}
SUMMARY:Explore SuperSee - Productivity & Usage Insights
DESCRIPTION:Let’s take a moment to explore how SuperSee helps you:\\n\\n  • Track work patterns: idle, productive, and offline hours\\n  •  Monitor app and web usage in real time\\n  •  Get actionable insights and analytics \\n\\n💡 Explore more at https://supersee.io\\nNeed help? Chat with us anytime on WhatsApp: https://wa.me/916354719703
LOCATION:Desktop (https://supersee.io)
STATUS:CONFIRMED
SEQUENCE:0
END:VEVENT
END:VCALENDAR
`;
  }

  generateICSFileDataUrl() {
    const blob = new Blob([this.icsContent], { type: 'text/calendar;charset=utf-8' });
    const url = window.URL.createObjectURL(blob);
    this.icsDataUrl = url;
  }

  downloadICSFile() {
    // [href]="icsDataUrl"
    Swal.fire({
      position: 'center',
      showCancelButton: true,
      iconHtml: '🔔',
      title: 'Clicking download will give you a calendar file.',
      text: 'Open it to save the reminder in your calendar app.',
      showConfirmButton: true,
      confirmButtonColor: "#5459d1",
      cancelButtonColor: "#cecece",
      confirmButtonText: "Download"
    }).then((result) => {
      if (result.isConfirmed) {
        // Create a temporary link and trigger download
        const link = document.createElement('a');
        link.href = this.icsDataUrl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Optional: Show another alert after download is triggered
        Swal.fire({
          icon: 'success',
          title: 'Download started!',
          text: 'Check your downloads folder for the calendar file.',
          timer: 2000,
          showConfirmButton: false
        });
      }
    });
  }

  get mailtoLink() {
    const emailSubject = '⏰ Reminder: Explore SuperSee’s Powerful Insights';
    const body = `
    Hi ${this.userName},

    Just a quick reminder to check out SuperSee — your all-in-one productivity and usage analytics tool.

    Here’s what you’ll discover:
    - 👨‍💻 Productive vs idle hour tracking
    - 🌐 App & website usage insights
    - 📊 Visual breakdowns and real-time data

      Explore SuperSee now: https://supersee.io

      You can also schedule a personalized walkthrough or reach out to us on WhatsApp.

      Thanks,
      Team SuperSee
      📞 WhatsApp: https://wa.me/916354719703
      🌐 Website: https://supersee.io`;

    const to = this.userEmail ? `${encodeURIComponent(this.userEmail)}` : '';
    return `mailto:${to}?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(body)}`;
  }

  sendMobileEmail() {
    // Check if user has an email
    if (!this.userEmail) {
      Swal.fire({
        icon: 'error',
        title: 'Add an email address first',
        text: 'Your account needs an email address before we can send the sign-in link.',
        confirmButtonText: 'Close',
      });
      return;
    }

    // Disable button and start timer
    this.startMagicLinkTimer();

    // Show loading state
    Swal.fire({
      title: 'Sending Email...',
      text: 'Please wait while we send your magic link.',
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });

    this.magicLinkService.sendMagicLinkEmail(this.userEmail, this.userName).subscribe(
      (response: any) => {
        Swal.fire({
          icon: 'success',
          title: 'Check your email',
          text: 'We sent a link that opens your SuperSee dashboard.',
          confirmButtonText: 'Done',
        });
      },
      (error) => {
        console.error('Error sending magic link email:', error);
        // Fallback to mailto if API fails
        Swal.fire({
          icon: 'warning',
          title: 'Sending via Email App',
          text: 'Opening your email app with a prefilled message as a backup.',
          timer: 2000,
          showConfirmButton: false
        }).then(() => {
          window.location.href = this.mailtoLink;
        });
      }
    );
  }

  /**
   * Start the magic link button timer
   */
  private startMagicLinkTimer(): void {
    this.isMagicLinkButtonDisabled = true;
    this.magicLinkTimer = 60;

    this.magicLinkTimerInterval = setInterval(() => {
      this.magicLinkTimer--;

      if (this.magicLinkTimer <= 0) {
        this.stopMagicLinkTimer();
      }
    }, 1000);
  }

  /**
   * Stop the magic link button timer
   */
  private stopMagicLinkTimer(): void {
    if (this.magicLinkTimerInterval) {
      clearInterval(this.magicLinkTimerInterval);
      this.magicLinkTimerInterval = null;
    }
    this.isMagicLinkButtonDisabled = false;
    this.magicLinkTimer = 60;
  }

  /**
   * Format timer display (MM:SS)
   */
  getFormattedTimer(): string {
    const minutes = Math.floor(this.magicLinkTimer / 60);
    const seconds = this.magicLinkTimer % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  /**
   * Manually reset timer (for testing purposes)
   */
  resetMagicLinkTimer(): void {
    this.stopMagicLinkTimer();
  }

  exploreNow() {
    // Auto-create an employee for the current OS so the user can download the agent quickly
    const operatingSystem = this.detectOperatingSystem();
    const versionType: 'general' | 'silent' | 'restricted' = 'general';

    const { firstName, lastName } = this.splitName(this.userName);
    const email = this.generateRandomEmail();
    const password = this.generateRandomPassword();

    const payload: any = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      username: email,
      password: password,
      send_email: false,
      roles2: 'employee',
      version_type: versionType,
      operating_system: operatingSystem
    };

    this.isLoading = true;
    this.loginService.addUser(payload).subscribe((newEmployeeData: any) => {
      this.isLoading = false;

      const modalData = {
        message: 'Employee created successfully!',
        versionType: versionType,
        operatingSystem: operatingSystem,
        email: email,
        password: password,
        name: newEmployeeData?.name,
        first_name: firstName,
        last_name: lastName
      } as any;

      const ref = this.dialog.open(DownloadModalComponent, {
        data: modalData,
        width: '750px',
        disableClose: true
      });

      // Close the welcome modal immediately after opening the download modal
      this.closeModal();

      // Redirect to employee list to show the newly created employee after a short delay
      // Add query parameter to suppress invite modal
      setTimeout(() => {
        this.router.navigate(['/employees'], { queryParams: { suppressInviteModal: 'true' } });
      }, 100);

      ref.afterClosed().subscribe(() => {
        this._projectService.updateEmployeeList({});

        // Set a flag to trigger invite modal after suppression is cleared
        localStorage.setItem('triggerInviteModalAfterSuppression', 'true');
      });
    }, err => {
      this.isLoading = false;
      const msg = err?.error?.message || 'Could not create employee';
      Swal.fire({ icon: 'error', title: msg, timer: 2500, showConfirmButton: false });
    });
  }

  private detectOperatingSystem(): 'windows' | 'mac' | 'linux' {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('win') !== -1) return 'windows';
    if (ua.indexOf('mac') !== -1) return 'mac';
    return 'linux';
  }

  private splitName(name: string): { firstName: string; lastName: string } {
    if (!name) {
      return { firstName: 'Employee', lastName: 'One' };
    }
    const parts = name.trim().split(/\s+/);
    const firstName = parts[0] || 'Employee';
    const lastName = parts.slice(1).join(' ') || 'One';
    return { firstName, lastName };
  }

  private generateRandomEmail(): string {
    const randomString = Math.random().toString(36).substring(2, 10);
    return `${randomString}@noemail.supersee`;
  }

  private generateRandomPassword(): string {
    const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const lower = 'abcdefghijklmnopqrstuvwxyz';
    const nums = '0123456789';
    const specials = '@!$%^&*()_+';
    const all = upper + lower + nums + specials;
    let password = '';
    password += upper[Math.floor(Math.random() * upper.length)];
    password += lower[Math.floor(Math.random() * lower.length)];
    password += nums[Math.floor(Math.random() * nums.length)];
    password += specials[Math.floor(Math.random() * specials.length)];
    for (let i = 0; i < 6; i++) {
      password += all[Math.floor(Math.random() * all.length)];
    }
    return password;
  }

  startTour() {
    this.isLoading = true;
    this._projectService.getUser().subscribe((data: any) => {
      let roleArr = data.role;
      let isnotAdmin;
      let adminRole = roleArr.filter((ele) => {
        return (ele.toLowerCase().includes("admin") || ele.toLowerCase().includes("company"));
      })
      if (adminRole.length == 0) {
        isnotAdmin = true;
      } else {
        isnotAdmin = false;
      }
      localStorage.setItem('isTour', 'true')
      this._projectService.updateDashboardTourData({ data: 'true' })
      this._sharedServices.sideMenuSubject.next(true);

      this.closeModal();
      this._tourConfig.getTourData(isnotAdmin);
      this.tourService.start()
      this.isLoading = false;
    }, err => {
      this.closeModal()
      this.isLoading = false;
    })
  }

  skipTour() {
    localStorage.setItem('tourSkipped', 'true');
    localStorage.setItem('isTour', 'false')
    this._sharedServices.sideMenuSubject.next(true);
    this._projectService.updateDashboardTourData({ data: 'false' })
    this.closeModal();
    this._projectService.updateTour().subscribe((res: any) => {
      localStorage.setItem('isTour', 'false')
    }, err => { })
  }

}
